import {useTranslation} from 'react-i18next'

import {HROC_CHECKLISTS_WIDGET_NAMESPACE} from '../consts'

export const useWidgetTranslation = () => {
  return useTranslation(HROC_CHECKLISTS_WIDGET_NAMESPACE)
}
